<template>
<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 479.998 479.998" style="enable-background:new 0 0 479.998 479.998;" xml:space="preserve">
<g>
	<g>
		<path d="M364,0H44C21.92,0.026,4.026,17.92,4,40v256c-0.002,18.245,12.342,34.178,30.008,38.736l4-15.488
			C27.405,316.514,19.996,306.95,20,296V40c0-13.255,10.745-24,24-24h320c13.255,0,24,10.745,24,24v8h16v-8
			C403.974,17.92,386.08,0.026,364,0z"/>
	</g>
</g>
<g>
	<g>
		<rect x="36" y="32" width="16" height="16"/>
	</g>
</g>
<g>
	<g>
		<rect x="68" y="32" width="16" height="16"/>
	</g>
</g>
<g>
	<g>
		<rect x="100" y="32" width="16" height="16"/>
	</g>
</g>
<g>
	<g>
		<path d="M473.656,442.344l-75.88-75.88c3.986-7.115,7.174-14.649,9.504-22.464H420v-16h-9.28
			c3.013-19.365,0.69-39.185-6.72-57.328V192h-16v50.944c-4.751-6.069-10.112-11.634-16-16.608V160h-16v55.152
			c-5.121-2.968-10.472-5.523-16-7.64V128h-16v74.656c-5.272-1.138-10.619-1.889-16-2.248V144h-16v56.408
			c-5.381,0.359-10.728,1.11-16,2.248V176h-16v31.512c-5.528,2.117-10.878,4.672-16,7.64V168h-16v58.336
			c-5.888,4.974-11.249,10.539-16,16.608V184h-16v86.672c-7.41,18.143-9.733,37.963-6.72,57.328H84v16h108.72
			c17.546,59.182,79.746,92.934,138.927,75.388c11.662-3.458,22.682-8.796,32.625-15.804l74.072,74.072
			c3.124,3.123,8.188,3.123,11.312,0l24-24C476.779,450.532,476.779,445.468,473.656,442.344z M300,408
			c-52.996-0.057-95.943-43.004-96-96c0-53.019,42.981-96,96-96s96,42.981,96,96S353.019,408,300,408z M444,460.688l-67.296-67.296
			c4.36-4.12,8.386-8.579,12.04-13.336L456.688,448L444,460.688z"/>
	</g>
</g>
<g>
	<g>
		<path d="M300,232c-44.183,0-80,35.817-80,80c0,44.183,35.817,80,80,80c44.183,0,80-35.817,80-80
			C379.952,267.837,344.163,232.048,300,232z M300,376c-22.836-0.029-43.926-12.224-55.344-32h110.688
			C343.926,363.776,322.836,375.971,300,376z M238.104,328c-6.437-24.36,2.158-50.22,21.896-65.88V312h16v-59.288
			c5.13-2.076,10.509-3.474,16-4.16V312h16v-63.448c5.491,0.686,10.87,2.084,16,4.16V312h16v-49.88
			c19.738,15.66,28.333,41.52,21.896,65.88H238.104z"/>
	</g>
</g>
<g>
	<g>
		<path d="M412,64H92c-22.08,0.026-39.974,17.92-40,40v256c0.026,22.08,17.92,39.974,40,40h104v-16H92c-13.255,0-24-10.745-24-24
			V104c0-13.255,10.745-24,24-24h320c13.255,0,24,10.745,24,24v256c-0.001,5.845-2.134,11.488-6,15.872l12,10.584
			c6.448-7.304,10.004-16.713,10-26.456V104C451.974,81.92,434.08,64.026,412,64z"/>
	</g>
</g>
<g>
	<g>
		<rect x="84" y="96" width="16" height="16"/>
	</g>
</g>
<g>
	<g>
		<rect x="116" y="96" width="16" height="16"/>
	</g>
</g>
<g>
	<g>
		<rect x="148" y="96" width="16" height="16"/>
	</g>
</g>
<g>
	<g>
		<rect x="100" y="264" width="16" height="48"/>
	</g>
</g>
<g>
	<g>
		<rect x="132" y="216" width="16" height="96"/>
	</g>
</g>
<g>
	<g>
		<rect x="164" y="240" width="16" height="72"/>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
</template>
